import {mixins} from "../app/mixin";

mixins.push({
    el: '.blogCategoryPage',
    data() {
        return {
            posts: window.posts,
            searchQuery: '',
            filteredPosts: []
        };
    },
    methods: {
        filterSearchQuery() {
            this.filteredPosts = this.posts.filter(o => o.title.toLowerCase().includes(this.searchQuery.toLowerCase())).map(o => o.id);
        }
    },
    mounted() {
        this.filteredPosts = this.posts.map(o => o.id);
    },
});